import React from 'react';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100 text-gray-800">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-blue-600">404</h1>
        <p className="mt-4 text-xl font-semibold">Oops! Page not found.</p>
        <p className="mt-2 text-gray-600">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6">
          <a
            href="/"
            className="px-6 py-3 text-white bg-blue-600 hover:bg-blue-700 rounded-md text-lg shadow-md transition-all"
          >
            Go Back Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
